<div class="qa-multi-preview" aria-hidden="true" *ngIf="question.elements?.length">
  <div class="qa-multi-preview-scroll">
    <table [style.min-width.px]="question.elements.length * 120">
      <colgroup><col *ngFor="let field of question.elements" [style.width.%]="fieldWidth(field)"></colgroup>
      <thead><tr>
        <th *ngFor="let field of question.elements; let position = index" [attr.data-qa-option-focus]="'field-' + position">
          {{(field.title?.[locale] | striptags | htmldecode) || (_(KEYS.EDITOR.TITLE) + ' ' + (position + 1))}}
          <span *ngIf="field.options?.mandatory">*</span>
        </th>
      </tr></thead>
      <tbody><tr><td *ngFor="let field of question.elements; let position = index" [attr.data-qa-option-focus]="'field-' + position">
        <div class="qa-multi-preview-input">
          <span>{{field.options?.hint?.[locale] || fieldTypeLabel(field)}}</span>
          <i class="fa" [ngClass]="field.format === 'date' ? 'fa-calendar-o' : field.format === 'singleChoice' ? 'fa-angle-down' : field.format === 'numeric' ? 'fa-sort-numeric-asc' : 'fa-pencil-square-o'"></i>
        </div>
      </td></tr></tbody>
    </table>
  </div>
  <div *ngIf="question.options?.repeatable" class="qa-multi-preview-repeat"><i class="fa fa-plus"></i> {{_(KEYS.EDITOR.ADD_ENTRY)}}</div>
</div>
